export default "__VITE_ASSET__fEAcPHhw__"